document.addEventListener("DOMContentLoaded", function() {

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  // Handle "ADD FROM REGISTER" button - save form first, then open modal
  var addFromRegisterBtn = document.getElementById('addFromRegisterBtn');
  if (addFromRegisterBtn) {
    addFromRegisterBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var form = document.getElementById('ad-form');
      if (!form) return;

      var modalTarget = this.getAttribute('data-bs-target');
      var formData = new FormData(form);
      // Add a flag to indicate this is a save-before-modal action
      formData.append('save_before_modal', 'true');

      // Disable button during save
      this.disabled = true;
      var originalText = this.innerHTML;
      this.innerHTML = '<span>Saving...</span>';

      fetch(form.action, {
        method: 'PUT',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
      })
      .then(response => {
        if (response.ok) {
          // Open the modal after successful save
          var modalElement = document.querySelector(modalTarget);
          if (modalElement) {
            var modal = new bootstrap.Modal(modalElement);
            modal.show();
          }
        } else {
        }
      })
      .catch(error => {
      })
      .finally(() => {
        // Re-enable button
        this.disabled = false;
        this.innerHTML = originalText;
      });
    });
  }

  function updateCountdown(auction) {
    const countdownElement = auction.querySelector('.countdown');
    if (!countdownElement) return;
    
    const endTimeAttr = auction.getAttribute('data-end-time');
    if (!endTimeAttr) return;
    
    const endTime = new Date(endTimeAttr);
    const now = new Date();
    const timeRemaining = endTime - now;

    if (timeRemaining <= 0) {
      // Find the times_up_label in the same container
      var timesUpLabel = 'Times up';
      var closestContainer = auction.closest('.d-inline-block, .text-center, .text-16');
      if (closestContainer) {
        var timesUpInput = $(closestContainer).find('input[id^="times_up_label"]');
        if (timesUpInput.length) {
          timesUpLabel = timesUpInput.val();
        } else {
          // Fallback to global times_up_label
          var globalLabel = $("#times_up_label").val();
          if (globalLabel) timesUpLabel = globalLabel;
        }
      } else {
        // Fallback to global times_up_label
        var globalLabel = $("#times_up_label").val();
        if (globalLabel) timesUpLabel = globalLabel;
      }
      countdownElement.innerHTML = timesUpLabel;
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Format hours, minutes, and seconds to always have two digits
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      var dayLabel = $("#days_translation").val();
      countdownElement.innerHTML = `${days} ${dayLabel} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }
  }

  function updateAllCountdowns() {
    // Re-query elements on each update to include dynamically loaded content
    const auctions = document.querySelectorAll('.auction_remaining_time');
    auctions.forEach(auction => updateCountdown(auction));
  }

  // Clear any existing interval to avoid duplicates
  if (window.countdownInterval) {
    clearInterval(window.countdownInterval);
  }

  // Update the countdown every second
  window.countdownInterval = setInterval(updateAllCountdowns, 1000);

  // Initialize countdown display
  updateAllCountdowns();
});

$(document).ready(function(){

  url = window.location.href;
  url = url.split("/");
  if (url[6] == "edit?editable=false&step=3"){
    $("#editAuctionModal3").modal("show");
  }

  if (url[6] == "edit?editable=false&step=4"){
    $("#editAuctionModal4").modal("show");
  }

  if (url[5] == "manage_active_auctions?published=true"){
    $("#publishedActiveAuctionModal").modal("show");
  }

  if (url[5] == "manage_active_notices?published=true"){
    $("#publishedActiveNoticeModal").modal("show");
  }

  if (url[5] == "manage_active_ads?published=true"){
    $("#publishedActiveAdModal").modal("show");
  }

  // step 1
  $(document).on('click', '.selected_seller',  function() {
    if ($(this).is(':checked')){
      $(".selected_seller").prop('checked', false);
      $(this).prop('checked', true);
    }else{
      $(".selected_seller").prop('checked', true);
    }
  });

  $(document).on("click", "#user_accept_terms_of_use", function(){
    if ($(this).is(':checked')){
      $(".create_an_account").removeClass("disableattchmentbutton");
      $(".create_an_account").attr('disabled', false);
    }else{
      $(".create_an_account").addClass("disableattchmentbutton");
    }
  });

  $(document).on('change', '.upload_ad_attachment',  function() {
    var idArr = this.id.split("_");
    var id = idArr[idArr.length - 2];
    var ad_id = $("#ad_id").val();
    var form = $(this).closest('#ad-form-1');
    var authenticity_token = $(form).find('#authenticity_token').val();

    var attachment_name = $("#ad_attachment_attachment_" + id + '_name').val();
    var attachment_date = $("#ad_attachment_attachment_" + id + '_date').val();
    var images = $("#ad_attachment_attachment_" + id + '_attachment')[0].files

    var formData = new FormData();

    var obj = {};
    obj["id"] = ad_id;
    obj = JSON.stringify(obj);

    formData.append('attachment_name',attachment_name);
    formData.append('attachment_date',attachment_date);
    formData.append('attachment',images[0]);
    formData.append('authenticity_token',authenticity_token);
    formData.append('user',obj);

    $.ajax({
      type:'PUT',
      url:'/admin/auctions/' + ad_id + '/upload_attachment',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  // step 2
  $(document).on('change', '#auction_images',  function() {
    var ad_id = $("#ad_id").val();
    var form = $(this).closest('#ad-form');
    var images = $(form).find('#auction_images')[0].files

    var formData = new FormData();
    // formData.append('attachment',images[0]);

    // Read selected files
    var totalfiles = document.getElementById('auction_images').files.length;
    for (var index = 0; index < totalfiles; index++) {
      formData.append("files[]", document.getElementById('auction_images').files[index]);
    }

    $.ajax({
      url: '/admin/auctions/' + ad_id + '/upload_auction_image',
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  $(document).on("click", ".active_principal_private", function(){
    $('.active_principal_private').addClass('btn-primary');
    $('.active_principal_company').removeClass('btn-primary');
    $("#auction_principal_customer_type").val("PRIVATE");
    $( "#principal_company_info" ).addClass( "hide" );
    $( "#principal_private_info" ).removeClass( "hide" )
  });

  $(document).on("click", ".active_principal_company", function(){
    $('.active_principal_company').addClass('btn-primary');
    $('.active_principal_private').removeClass('btn-primary');
    $("#auction_principal_customer_type").val("COMPANY");
    $( "#principal_private_info" ).addClass( "hide" );
    $( "#principal_company_info" ).removeClass( "hide" );
  });

  $(document).on('click', '#groupAd',  function() {
    $(".group_ad_type").removeClass("disableattchmentbutton");
  });

  $(document).on('click', '#singleAd',  function() {
    $(".group_ad_type").addClass("disableattchmentbutton");
  });

  $(document).on('change', '#auction_group_ad_template_id',  function() {
    var group_ad_type = $(this).val();
    var form = $(this).closest('#ad-form-1');
    var auction_ad_type = $(form).find('#groupAd').val();
    var group_ad_template_id = $(form).find(this).val();
    var ad_id = $("#group_ad_id").val();
    var obj = {};
    obj["ad_type"] = auction_ad_type;
    obj["group_ad_template_id"] = group_ad_template_id;

    $.ajax({
      url: '/admin/auctions/' + ad_id,
      type: 'PUT',
      data: {auction : obj, step: 1}
    });
  });

  $(document).on('click', '#auction_confirm_display_times_get',  function() {
    $("#display_time_info").removeClass("hide");
  });

  $(document).on('click', '#auction_confirm_display_times_separate, #auction_confirm_display_times_view',  function() {
    $("#display_time_info").addClass("hide");
  });

  $(document).on('click', '#auction_has_different_address',  function() {
    if ($(this).is(':checked')){
      $("#different_address_info").removeClass("hide");
      $("#auction_pickup_address").val("");
      $("#auction_pickup_post_number").val("");
      $("#auction_pickup_city").val("");
    } else{
      $("#different_address_info").addClass("hide");
      $("#auction_pickup_address").val($("#current_user_pickup_address_infoo").val());
      $("#auction_pickup_post_number").val($("#current_user_pickup_post_number_info").val());
      $("#auction_pickup_city").val($("#current_user_pickup_city_info").val());
    }
  });

  $(document).on('click', '.clear_pickup_address',  function() {
    $("#auction_pickup_address").val("");
    $("#auction_pickup_post_number").val("");
    $("#auction_pickup_city").val("");
  });

  $(document).on('click', '#auction_has_separate_client',  function() {
    if ($(this).is(':checked')){
      $("#separate_client_info").removeClass("hide");
    }else{
      $("#separate_client_info").addClass("hide");
    }
  });

  $(document).on('click', '.selected_branch_office',  function() {
    if ($(this).is(':checked')){
      $(".selected_branch_office").prop('checked', false);
      $(this).prop('checked', true);
    }else{
      $(".selected_branch_office").prop('checked', true);
    }
  });

  $(document).on('click', '.clear_auction_start_date',  function() {
    $("#auction_auction_date").val("");
    $("#auction_start_time_start_hours").val("");
    $("#auction_start_time_start_minutes").val("");
  });

  $(document).on('click', '.clear_publication_date',  function() {
    $("#auction_publication_date").val("");
    $("#post_time_end_hours").val("");
    $("#post_time_end_minutes").val("");
  });

  // step 3
  $(document).on('click', '#auction_value_added_tax_no',  function() {
    if ($(this).is(':checked')){
      $("#price_with_vat").addClass("hide");
      $(".confirmed_vat_label").removeClass("hide");
      $(".confirm_vat_label").addClass("hide");
      $("#auction_vat_type").val("0,0");
      $("#auction_vat_type").attr('disabled', true);
    }else{
      $("#price_with_vat").removeClass("hide");
      $(".confirmed_vat_label").addClass("hide");
      $(".confirm_vat_label").removeClass("hide");
      $("#auction_vat_type").attr('disabled', false);
    }
  });

  $(document).on('click', '#auction_value_added_tax_yes',  function() {
    if ($(this).is(':checked')){
      $("#price_with_vat").removeClass("hide");
      $(".confirmed_vat_label").addClass("hide");
      $(".confirm_vat_label").removeClass("hide");
      $("#auction_vat_type").attr('disabled', false);
      $("#auction_vat_type").val($("#auction_vat_type_info").val());
    }else{
      $("#price_with_vat").addClass("hide");
      $(".confirmed_vat_label").removeClass("hide");
      $(".confirm_vat_label").addClass("hide");
      $("#auction_vat_type").val("0,0");
      $("#auction_vat_type").attr('disabled', true);
    }
  });

  $(document).on('keyup, change', '#auction_starting_price_with_vat, #auction_vat_type',  function() {
    var price_without_vat = $("#auction_starting_price_with_vat").val();
    var auction_vat_type = $("#auction_vat_type").val();

    if (auction_vat_type == "0,0"){
      var price_with_vat = checkNumericValue(price_without_vat)
    }else{
      var price_with_vat = checkNumericValue(price_without_vat) / (1 + (checkNumericValue(auction_vat_type) / 100))
    }
    $("#auction_starting_price_without_vat").val(checkNumericValue(price_with_vat));
    $("#starting_price_withh_vat").val(checkNumericValue(price_with_vat));
    $(".starting_price_with_vat").val(checkNumericValue(price_with_vat));
    var vat_price = checkNumericValue(price_with_vat) - checkNumericValue(price_without_vat)
    $("#vat_price_in_eur").val(checkNumericValue(vat_price));
    $(".sendInvoiceButton").removeClass("disableattchmentbutton");
  });

  $(document).on('keyup', '#auction_maximum_bid',  function() {
    var minimum_ad = $("#auction_minimum_bid").val();
    var maximum_ad = $(this).val();
    setTimeout(function () {
      if(checkNumericValue(minimum_ad) > checkNumericValue(maximum_ad)){
        $("#auction_minimum_maximum_increase_notice").html("<div class='alert alert-warning alert-dismissible'>The maximum increase must be a higher value than the minimum increase.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".checkMandatory").addClass("disableattchmentbutton");
      } else {
        $(".checkMandatory").removeClass("disableattchmentbutton");
        $("#auction_minimum_maximum_increase_notice").html("");
      }
    }, 500);
  });

  $(document).on('keyup', '#auction_minimum_bid',  function() {
    var minimum_ad = $(this).val();
    setTimeout(function () {
      if(minimum_ad < 5){
        $("#auction_minimum_maximum_increase_notice").html("<div class='alert alert-warning alert-dismissible'>The maximum increase must be a higher than 5.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".checkMandatory").addClass("disableattchmentbutton");
      } else {
        $(".checkMandatory").removeClass("disableattchmentbutton");
        $("#auction_minimum_maximum_increase_notice").html("");
      }
    }, 500);
  });

  $(document).on('click', '#immediate_sale_ad',  function() {
    if ($(this).is(':checked')){
      $("#immediate_purchase_date_info").removeClass("hide");
      $("#scheduled_purchase_date_info").addClass("hide");
      $("#auction_auction_date").removeClass("mandatory_field");
      $(".clear_auction_start_date").click();

      // Clear any date validation errors when switching to immediate
      $("#auction_publication_date_notice").html("");
      $(".checkMandatory").removeClass("disableattchmentbutton");

      // Re-validate form after changing mandatory fields (universal)
      var form = $(this).closest('form');
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
    }else{
      $("#immediate_purchase_date_info").addClass("hide");
      $("#scheduled_purchase_date_info").removeClass("hide");
      $("#auction_auction_date").addClass("mandatory_field");
      // Re-validate form after changing mandatory fields (universal)
      var form = $(this).closest('form');
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
    }
  });

  $(document).on('click', '#scheduled_sale_ad',  function() {
    if ($(this).is(':checked')){
      $("#scheduled_purchase_date_info").removeClass("hide");
      $("#immediate_purchase_date_info").addClass("hide");
      $("#auction_auction_date").addClass("mandatory_field");
      // Re-validate form after changing mandatory fields
      var form = $(this).closest('form');
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
    }else{
      $("#scheduled_purchase_date_info").addClass("hide");
      $("#auction_auction_date").removeClass("mandatory_field");
      $("#immediate_purchase_date_info").removeClass("hide");
      $(".clear_auction_start_date").click();
      // Re-validate form after changing mandatory fields
      var form = $(this).closest('form');
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
    }
  });

  $(document).on('click', '#not_specified',  function() {
    if ($(this).is(':checked')){
      $("#fixed_price_setting_info").addClass("hide");
      $("#auction_starting_price_without_vat").removeClass("mandatory_field");
      $("#auction_vat_type").removeClass("mandatory_field");
      $("#auction_starting_price_with_vat").removeClass("mandatory_field");
      $("#auction_starting_price_without_vat").val("");
    }else{
      $("#fixed_price_setting_info").removeClass("hide");
      $("#auction_starting_price_without_vat").addClass("mandatory_field");
      $("#auction_vat_type").addClass("mandatory_field");
      $("#auction_starting_price_with_vat").addClass("mandatory_field");
    }
  });

  $(document).on('click', '#fixed_price_settings',  function() {
    if ($(this).is(':checked')){
      $("#fixed_price_setting_info").removeClass("hide");
      $("#auction_starting_price_without_vat").addClass("mandatory_field");
      $("#auction_vat_type").addClass("mandatory_field");
      $("#auction_starting_price_with_vat").addClass("mandatory_field");
    }else{
      $("#fixed_price_setting_info").addClass("hide");
      $("#auction_starting_price_without_vat").removeClass("mandatory_field");
      $("#auction_vat_type").removeClass("mandatory_field");
      $("#auction_starting_price_with_vat").removeClass("mandatory_field");
    }
  });

  $(document).on('click', '#separate_with_seller',  function() {
    if ($(this).is(':checked')){
      $("#more_pick_up_info").addClass("hide");
      $(".auction_pickup_info").val("");
    }else{
      $("#more_pick_up_info").removeClass("hide");
    }
  });

  $(document).on('click', '#more_pick_up_details',  function() {
    if ($(this).is(':checked')){
      $("#more_pick_up_info").removeClass("hide");
    }else{
      $("#more_pick_up_info").addClass("hide");
      $(".auction_pickup_info").val("");
    }
  });

  // step 4
  $(document).on('click', '#auction_save_as_group_ad',  function() {
    if ($(this).is(':checked')){
      $("#group_ad_template_content").removeClass("hide");
      $("#auction_group_ad_template_name").addClass("mandatory_field");
    }else{
      $("#group_ad_template_content").addClass("hide");
      $("#auction_group_ad_template_name").removeClass("mandatory_field");
    }
  });

  $(document).on('click', '.form-check-input',  function() {
    if ($(this).is(':checked')){
      $(this).closest("li").addClass("checked");
    }else{
      $(this).closest("li").removeClass("checked");
    }
  });

  $(document).on('click', '.bid_offer_button',  function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if ($(this).hasClass('disableattchmentbutton') || $(this).prop('disabled')) {
      return false;
    }

    var id = getId(this.id); // This is offer.id for the route
    // Get auction_id from button's data attribute or container's data attribute
    var auction_id = $(this).attr('data-auction-id') || $(this).closest('.items-type-1').attr('data-auction-id') || $("#auction_id_"+ id).val();
    // Get offer_amount using auction.id (for compatibility with live updates)
    var offer_amount = $("#bid_offer_amount_"+ auction_id).val();
    // Get user_id using auction.id (for compatibility with live updates)
    var user_id = $("#user_id_"+ auction_id).val() || $("#user_id_"+ id).val();

    if (!offer_amount || !auction_id || !user_id) {
      alert('Error: Missing required information. Please refresh the page and try again.');
      return false;
    }

    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/'+ id +'/save_an_offer',
        type: 'PUT',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          offer: {
            offer_amount: offer_amount,
            auction_id: auction_id,
            user_id: user_id
          }
        },
        success: function(data) {
          window.location.reload();
        },
        error: function(xhr) {
          $("#loader-image").hide();
          window.location.reload();
        }
      });
    }, 500);

    return false;
  });

  $(document).on('click', '.wishlist_offer_button',  function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if ($(this).hasClass('disableattchmentbutton') || $(this).prop('disabled')) {
      return false;
    }

    var id = getId(this.id);
    var offer_amount = $("#wishlist_offer_"+ id).val();
    var wish_id = $("#wish_id_"+ id).val();
    var auction_id = $("#auction_id_"+ id).val();
    var user_id = $("#user_id_"+ id).val();

    if (!offer_amount || !auction_id || !user_id) {
      alert('Error: Missing required information. Please refresh the page and try again.');
      return false;
    }

    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/'+ id +'/save_wishlist_offer',
        type: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          offer: {
            offer_amount: offer_amount,
            auction_id: auction_id,
            user_id: user_id
          },
          wish_id: wish_id
        },
        success: function(data) {
          window.location.reload();
        },
        error: function(xhr) {
          $("#loader-image").hide();
          window.location.reload();
        }
      });
    }, 500);

    return false;
  });

  $(document).on('click', '.submit_publication_date',  function() {
    var id = $("#auction_id").val();

    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/auctions/'+ id +'/save_publication_date',
        type: 'PUT',
        data: {auction_id : id, publication_date : $("#auction_publication_date").val(), end_hour : $("#post_time_end_hours").val(), end_min : $("#post_time_end_minutes").val()}
      });
    }, 500);
  });

  $(document).on('click', '#active_auction_tab',  function() {    
    $(".active_auction_header").removeClass("hide");
    $(".upcoming_auction_header").addClass("hide");
  });

  $(document).on('click', '#upcoming_auction_tab',  function() {    
    $(".upcoming_auction_header").removeClass("hide");
    $(".active_auction_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#failed_auction_tab',  function() {    
    $(".failed_auction_header").removeClass("hide");
    $(".successful_auction_header").addClass("hide");
  });

  $(document).on('click', '#successful_auction_tab',  function() {    
    $(".successful_auction_header").removeClass("hide");
    $(".failed_auction_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#active_notice_tab',  function() {    
    $(".active_notice_header").removeClass("hide");
    $(".upcoming_notice_header").addClass("hide");
  });

  $(document).on('click', '#upcoming_notice_tab',  function() {    
    $(".upcoming_notice_header").removeClass("hide");
    $(".active_notice_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#failed_notice_tab',  function() {    
    $(".cancelled_notice_header").removeClass("hide");
    $(".successful_notice_header").addClass("hide");
  });

  $(document).on('click', '#successful_notice_tab',  function() {    
    $(".successful_notice_header").removeClass("hide");
    $(".cancelled_notice_header").addClass("hide");
    secondPagination()
  });

  $(document).on('click', '#active_ad_tab',  function() {    
    $(".active_ad_header").removeClass("hide");
    $(".upcoming_ad_header").addClass("hide");
  });

  $(document).on('click', '#upcoming_ad_tab',  function() {    
    $(".upcoming_ad_header").removeClass("hide");
    $(".active_ad_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '#cancelled_ad_tab',  function() {    
    $(".cancelled_ad_header").removeClass("hide");
    $(".successful_ad_header").addClass("hide");
  });

  $(document).on('click', '#successful_ad_tab',  function() {    
    $(".successful_ad_header").removeClass("hide");
    $(".cancelled_ad_header").addClass("hide");
    secondPagination();
  });

  $(document).on('click', '.accept_ad',  function() {
    var id = getId(this.id);
    $("#reject_ad_div_" + id).addClass("hide");
    $('#reject_ad_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#accept_ad_div_" + id).removeClass("hide");
    }else{
      $("#accept_ad_div_" + id).addClass("hide");
    }
  });

  $(document).on('click', '.reject_ad',  function() {
    var id = getId(this.id);
    $("#accept_ad_div_" + id).addClass("hide");
    $('#accept_ad_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#reject_ad_div_" + id).removeClass("hide");
    }else{
      $("#reject_ad_div_" + id).addClass("hide");
    }
  });

  $(document).on('click', '.accept_changes',  function() {
    var id = getId(this.id);
    $("#reject_changes_div_" + id).addClass("hide");
    $('#reject_changes_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#accept_changes_div_" + id).removeClass("hide");
    }else{
      $("#accept_changes_div_" + id).addClass("hide");
    }
  });

  $(document).on('click', '.reject_changes',  function() {
    var id = getId(this.id);
    $("#accept_changes_div_" + id).addClass("hide");
    $('#accept_changes_' + id).prop('checked', false); // Unchecks it
    if ($(this).is(':checked')){
      $("#reject_changes_div_" + id).removeClass("hide");
    }else{
      $("#reject_changes_div_" + id).addClass("hide");
    }
  });

  $(document).on('change', '#invoice_payment_receipt',  function() {
    var invoice_id = $("#invoice_id").val();
    var form = $(this).closest('#invoice_receipt_form');
    var images = $(form).find('#invoice_payment_receipt')[0].files

    var formData = new FormData();
    formData.append('attachment',images[0]);

    $.ajax({
      url: '/invoices/' + invoice_id + '/upload_payment_receipt',
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData
    });
  });

  $(document).on('keyup, change', '#seller_price_without_vat, #seller_vat_type',  function() {
    var price_without_vat = $("#seller_price_without_vat").val();
    var seller_vat_type = $("#seller_vat_type").val();

    if (seller_vat_type == "0,0"){
      var price_with_vat = checkNumericValue(price_without_vat)
    }else{
      var price_with_vat = checkNumericValue(price_without_vat) * (1 + (checkNumericValue(seller_vat_type) / 100))
    }
    $("#seller_price_with_vat").val(checkNumericValue(price_with_vat));
    var vat_price = checkNumericValue(price_with_vat) - checkNumericValue(price_without_vat)
    $("#seller_vat_price_in_eur").val(checkNumericValue(vat_price));
    $(".sendInvoiceButton").removeClass("disableattchmentbutton");
  });

});

function secondPagination() {
  if ($('.second_pagination').length) {
    $(document).scroll(function() {
      var url = $('.second_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.second_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }
}

function checkNumericValue(number, decimal_points = 2) {
  if (number){
    return parseFloat(parseFloat(number.toString().replace(' ', '').replace(",", ".")).toFixed(decimal_points));
  }
  else{
    return 0;
  }
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}

$(document).ready(function() {
  if (window.location.pathname.includes('/admin/offers/check_own_wishlist') || 
      window.location.pathname.includes('/admin/offers/open_active_bids')) {
    import('channels/auction_channel').then(module => {
      if (module.subscribeToAllAuctionsOnPage) {
        module.subscribeToAllAuctionsOnPage();
      }
    }).catch(err => {});
  }
});

function round5(x)
{
    return Math.ceil(x / 5) * 5;
}